import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from 'app/shared/services/settings.service';
import { ToastrService } from 'ngx-toastr';
import { SettingsBaseComponent } from '../settings-base/settings-base.component';

@Component({
  selector: 'app-chamber-of-commerce-settings',
  templateUrl: './chamber-of-commerce-settings.component.html',
  styleUrls: ['./chamber-of-commerce-settings.component.scss']
})

export class ChamberOfCommerceSettingsComponent extends SettingsBaseComponent implements OnInit {

  constructor(protected formBuilder: FormBuilder, protected settingsService: SettingsService, protected toastrService: ToastrService, protected translateService: TranslateService) {
    super(formBuilder, settingsService, toastrService, translateService);
  }

  ngOnInit() {
  }
}
